import { graphql, useFragment } from "react-relay";

import type { DefaultComponentsProvider } from "scmp-app/components/article/article-render";
import { getArticleType } from "scmp-app/components/article/article-render/helpers";
import type { hooksPostiesArticleArticle$key } from "scmp-app/queries/__generated__/hooksPostiesArticleArticle.graphql";

import { GenericPostiesArticle } from "./generic-posties-article";

export const usePostiesArticle = (
  provider: DefaultComponentsProvider,
  article_: hooksPostiesArticleArticle$key,
) => {
  const article = useFragment(
    graphql`
      fragment hooksPostiesArticleArticle on Article
      @argumentDefinitions(
        customContents: { type: "[CustomContentInput]", defaultValue: [] }
        bodyType: { type: "BodyFormatTypeEnum", defaultValue: PARAGRAPH }
      ) {
        ...genericPostiesArticleContent
          @arguments(customContents: $customContents, bodyType: $bodyType)
        ...helpersGetArticleTypeArticle
      }
    `,
    article_,
  );

  const handleRenderPostiesArticle = () => {
    switch (getArticleType(article)) {
      default:
        return <GenericPostiesArticle provider={provider} reference={article} />;
    }
  };

  return {
    handleRenderPostiesArticle,
  };
};
